import { useNavigate } from "react-router-dom";
import { useState } from "react";
import * as Yup from "yup";

import Master from "../../../Layouts/Master";
import { useApi } from "../../../Hooks/Api";
import { useToast } from "../../../Hooks/Toast";
import Loading from "../../../Components/Loading/Loading";
import { Datepicker, Form, Text, Select } from "../../../Components/Form";
import { getStatus, serverErrorHandler } from "../../../Utils/Helpers";
import TitleBar from "../../../Components/TitleBar/TitleBar";

const validationSchema = Yup.object({
  title: Yup.string()
    .typeError("عنوان الزامی است")
    .required("عنوان الزامی است")
    .max(190, "عنوان نمی تواند بیشتر از 190 کاراکتر باشد"),
});

const Create = () => {
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const { post } = useApi();
  const { error, success } = useToast();
  const navigate = useNavigate();

  const submitForm = async (values, setSubmitingForm) => {
    setFormSubmitLoaing(true);
    await post(
      "/level",
      values,
      (res) => {
        success(`سطح مسابقات "${values?.title}" باموفقیت ایجاد شد.`);
        setFormSubmitLoaing(false);
        navigate("/level");
      },
      (err) => {
        console.log(err);
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error("لطفا خطاهای فرم را رفع کنید.");
        } else {
          error(`سطح مسابقات "${values?.title}" به علت خطا ایجاد نشد.`);
        }
        setFormSubmitLoaing(false);
      }
    );
  };
  return (
    <Master>
      <TitleBar
        title='ایجاد سطح مسابقات'
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/level'
      />
      <Form
        initialValues={{
          title: "",
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12 col-md-8'>
            <div className='row'>
              <div className='col-12'>
                <Text
                  title='عنوان'
                  name='title'
                  serverError={serverErrors.title}
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-4'></div>
        </div>
      </Form>
    </Master>
  );
};

export default Create;
